import { HttpVerb } from "../../constants";

const getSessionTime = async (sessionActivationTime = null) => {
  return window.ucSDK.api.instance?.authenticatedRequest({
    url: "/api/Timing/GetSessionTime/",
    method: HttpVerb.GET,
    params: {
      activationTime: sessionActivationTime ? sessionActivationTime : null
    }
  });
};

export default {
  getSessionTime
};
